import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';

const API_URL = (process.env.REACT_APP_API_URL || "/").replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const ListaModulos = () => {
  const { categoria_id } = useParams();
  const [modulos, setModulos] = useState([]);
  const [progreso, setProgreso] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const usuario = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    // Si todavía no tenemos usuario/legajo, no intentamos cargar nada
    if (!usuario.Legajo) return;

    const cargarDatos = async () => {
      try {
        const [modulosRes, progresoRes] = await Promise.all([
          fetch(`${API_URL}/api/capacitaciones/modulos/categoria/${categoria_id}`, {
            headers: getAuthHeaders()
          }),
          fetch(`${API_URL}/api/capacitaciones/progreso/${usuario.Legajo}`, {
            headers: getAuthHeaders()
          })
        ]);

        if (!modulosRes.ok || !progresoRes.ok) {
          throw new Error('Respuesta no válida del servidor');
        }

        const modulosData = await modulosRes.json();
        const progresoData = await progresoRes.json();

        if (modulosData.success) setModulos(modulosData.data);
        if (progresoData.success) setProgreso(progresoData.data);

        setLoading(false);
      } catch (err) {
        console.error('❌ Error al cargar módulos o progreso:', err);
        setError(true);
        setLoading(false);
      }
    };

    cargarDatos();
  }, [categoria_id, usuario.Legajo]); // usamos legajo en lugar de usuario.Legajo

  const estadoModulo = (modulo_id) => {
    const registro = progreso.find((p) => p.modulo_id === modulo_id);
    return registro?.estado_video || 'no_visto';
  };

  const moduloDesbloqueado = (orden) => {
    if (orden === 1) return true;
    const anterior = modulos.find((m) => m.orden === orden - 1);
    const registro = progreso.find((p) => p.modulo_id === anterior?.id);
    return registro?.aprobado === 1;
  };

  // Mientras no tengamos usuario, mostramos un loading (o redirigís, como prefieras)
  if (!usuario || !usuario.Legajo) {
    return (
      <Container className="py-4 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (loading) {
    return (
      <Container className="py-4 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-4 text-center">
        <Alert variant="danger">
          Error al cargar los módulos. Verificá que el servidor esté activo y los endpoints existan.
        </Alert>
      </Container>
    );
  }

  return (
    <div>
      <Navbar />
      <Container className="py-4">
        <h4>Módulos de la categoría</h4>
        <Row>
          {modulos.map((mod) => (
            <Col key={mod.id} md={6} className="mb-3">
              <Card className="option-card">
                <Card.Body>
                  <h5>{mod.titulo}</h5>
                  <p>Orden: {mod.orden}</p>
                  <p>Estado: {estadoModulo(mod.id)}</p>
                  {moduloDesbloqueado(mod.orden) ? (
                    <Button
                      variant="primary"
                      onClick={() => navigate(`/home/ver-modulo/${mod.id}`)}
                    >
                      Ver módulo
                    </Button>
                  ) : (
                    <Button variant="secondary" disabled>
                      Módulo bloqueado
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ListaModulos;
